import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import species_info from '../../data/species_info.json';

const SpeciesDropdown = ({ selectedSpecies, handleSpeciesChange }) => {
  const [selectedName, setSelectedName] = useState('CH4');
  const [selectedResolution, setSelectedResolution] = useState('monthly');

  // Group species by unique name
  const groupedSpecies = species_info.species.reduce((acc, item) => {
    const trimmedName = item.name.trim();
    if (!acc[trimmedName]) acc[trimmedName] = [];
    if (item.data_year) acc[trimmedName].push(item.data_year);
    return acc;
  }, {});

  const formatChemicalNotation = (formula) => {
    return formula.replace(/(\d+)/g, "<sub>$1</sub>");
  };

  const handleNameChange = (event) => {
    const newName = event.target.value;
    setSelectedName(newName);
    const availableResolutions = groupedSpecies[newName];
    const defaultResolution = availableResolutions?.[0] || 'monthly';
    setSelectedResolution(defaultResolution);
    handleSpeciesChange({ species: newName, resolution: defaultResolution });
  };
  
  const handleResolutionChange = (event) => {
    const resolution = event.target.value;
    setSelectedResolution(resolution);
    handleSpeciesChange({ species: selectedName, resolution });
  };

  // Notify parent on first mount
  useEffect(() => {
    handleSpeciesChange({ species: selectedName, resolution: selectedResolution });
  }, [handleSpeciesChange, selectedName, selectedResolution]);
  

  return (
    <Box display="flex" flexDirection="row" gap={2}>
      {/* First dropdown: Species */}
      <FormControl fullWidth>
        <InputLabel id="species-select-label">Select Species</InputLabel>
        <Select
          labelId="species-select-label"
          id="species-select"
          value={selectedName}
          label="Select Species"
          onChange={handleNameChange}
        >
          <MenuItem value="total">
            Total non-CO
            <span dangerouslySetInnerHTML={{ __html: formatChemicalNotation('2') }} />
            &nbsp;emissions
          </MenuItem>

          {Object.keys(groupedSpecies).map((speciesName) => {
            const item = species_info.species.find((s) => s.name.trim() === speciesName);
            return (
              <MenuItem key={speciesName} value={speciesName}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatChemicalNotation(speciesName),
                  }}
                />
                &nbsp;({item?.common_name || 'Unknown'})
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {/* Second dropdown: Resolution */}
      {groupedSpecies[selectedName] && groupedSpecies[selectedName].length > 1 && (
        <FormControl fullWidth>
          <InputLabel id="resolution-select-label">Select Time Resolution</InputLabel>
          <Select
            labelId="resolution-select-label"
            id="resolution-select"
            value={selectedResolution}
            label="Select Time Resolution"
            onChange={handleResolutionChange}
          >
            {groupedSpecies[selectedName].map((res, i) => (
              <MenuItem key={i} value={res}>
                {res.charAt(0).toUpperCase() + res.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default SpeciesDropdown;
